export { d100, degrees, clampTarget } from './dice';
export const MISSION_ROLL_CONTEXT_KEY = 'dw:mission:rollContext';
